// extracted by mini-css-extract-plugin
export default {"wrapper":"Zx-z","viewport":"_x-z","container":"ay-z","slide":"by-z"};